import { InfoCircle } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { IconWithTooltip } from '../../../filters/components/IconWithTooltip/IconWithTooltip';

type InfoRowProps = {
  labelKey: string;
  value: string;
  namespace: string;
  infoTooltip?: string;
};

function InfoRow({ labelKey, value, namespace, infoTooltip }: InfoRowProps) {
  const t = useTranslations(namespace);

  return (
    <div className="flex justify-between">
      <span className="text-foreground-subtle paragraph-s flex gap-1" data-testid={`row-${labelKey}-label`}>
        {t(labelKey)}
        {infoTooltip && (
          <IconWithTooltip tooltipContent={infoTooltip} ariaLabel={t('infoAriaLabel')}>
            <span data-testid={`row-${labelKey}-tooltip-icon`}>
              <InfoCircle size="extra-small" />
            </span>
          </IconWithTooltip>
        )}
      </span>
      <span className="text-foreground paragraph-s" data-testid={`row-${labelKey}-value`}>
        {value}
      </span>
    </div>
  );
}

export { InfoRow };
